<template>
  <section class="how-section">
    <v-container style="max-width: 1200px">
      <div class="text-center mb-14">
        <p class="section-eyebrow">{{ $t('howItWorks.eyebrow') }}</p>
        <h2 class="section-title">{{ $t('howItWorks.title') }}</h2>
      </div>

      <div
        v-for="(step, i) in steps"
        :key="i"
        class="mb-16"
      >
        <v-row align="center" :class="i % 2 !== 0 ? 'flex-row-reverse' : ''">
          <v-col cols="12" md="5" :class="i % 2 !== 0 ? 'pl-md-12' : 'pr-md-12'">
            <div class="step-number mb-5">{{ String(i + 1).padStart(2, '0') }}</div>
            <h3 class="step-title mb-4">{{ step.title }}</h3>
            <p class="step-desc mb-6">{{ step.desc }}</p>
            <ul class="step-list">
              <li v-for="(point, j) in step.points" :key="j" class="step-list-item">
                <v-icon small color="primary" class="mr-2">mdi-check-circle</v-icon>
                {{ point }}
              </li>
            </ul>
          </v-col>

          <v-col cols="12" md="7" :class="i % 2 !== 0 ? 'pr-md-12' : 'pl-md-12'">
            <div class="step-visual">
              <img :src="stepMeta[i].imageUrl" :alt="step.title" class="step-visual-img" />
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'HowItWorks',
  data() {
    return {
      stepMeta: [
        { icon: 'mdi-plus-circle-outline', iconColor: '#4257b2', bgColor: '#f0f2ff', imageUrl: '/assets/step1.png' },
        { icon: 'mdi-brain',               iconColor: '#7b1fa2', bgColor: '#f9f0ff', imageUrl: '/assets/step2.png' },
        { icon: 'mdi-trophy-outline',      iconColor: '#e65100', bgColor: '#fff8f0', imageUrl: '/assets/step3.png' },
      ],
    }
  },
  computed: {
    steps() {
      return this.$t('howItWorks.steps')
    },
  },
}
</script>

<style scoped>
.how-section {
  padding: 96px 16px;
  background: #f8f9fc;
}

.section-eyebrow {
  font-size: 0.8rem;
  font-weight: 700;
  color: #F77317;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 12px;
}

.section-title {
  font-size: 2.4rem;
  font-weight: 900;
  color: #4055AF;
  letter-spacing: -1px;
  line-height: 1.15;
  margin: 0;
}

.step-number {
  font-size: 3.5rem;
  font-weight: 900;
  color: #e8eaf6;
  letter-spacing: -2px;
  line-height: 1;
}

.step-title {
  font-size: 1.7rem;
  font-weight: 800;
  color: #4055AF;
  letter-spacing: -0.5px;
  line-height: 1.2;
}

.step-desc {
  font-size: 1rem;
  color: #666;
  line-height: 1.75;
}

.step-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.step-list-item {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: #444;
  font-weight: 500;
}

.step-visual {
  border-radius: 24px;
  overflow: hidden;
  width: 100%;
  aspect-ratio: 16 / 9;
  position: relative;
}

.step-visual-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 24px;
}
</style>
